import React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "../../Context/ThemeContext";

const ThemeToggle = () => {
  const { activeTheme, setTheme } = useTheme();
  const isDark = activeTheme === "dark";

  return (
    <button
      type="button"
      onClick={() => setTheme(isDark ? "light" : "dark")}
      className="theme-toggle inline-flex items-center rounded-full border px-2 py-1.5 text-xs font-medium transition"
      aria-label={`Switch to ${isDark ? "light" : "dark"} theme`}
      title={`Switch to ${isDark ? "light" : "dark"} theme`}
      aria-pressed={isDark}
    >
      <span
        className={`relative inline-flex h-7 w-14 items-center rounded-full px-1 transition ${
          isDark ? "bg-[#0f172a] text-white" : "bg-white/80 text-[#0061A4]"
        }`}
      >
        <span
          className={`absolute inline-flex h-5 w-5 items-center justify-center rounded-full transition duration-200 ${
            isDark
              ? "translate-x-7 bg-white text-[#0f172a] shadow-sm"
              : "translate-x-0 bg-[#0061A4] text-white shadow-sm"
          }`}
        >
          {isDark ? <Moon size={12} /> : <Sun size={12} />}
        </span>
      </span>
    </button>
  );
};

export default ThemeToggle;
